import { COOKIE_OPT_OUT_OPTION, PERFORMANCE_COOKIE_OPT_OUT } from '@configs'

import { setCookie } from '@utils/cookie'

export default function updateSaAndDcCookie(status) {
  setCookie(PERFORMANCE_COOKIE_OPT_OUT.SA, status, COOKIE_OPT_OUT_OPTION)
  setCookie(PERFORMANCE_COOKIE_OPT_OUT.DC, status, COOKIE_OPT_OUT_OPTION)
}
